<template>
  <TripsMarker :coordinates="coordinates" foreground>
    <IconTripsStartMarker width="50" height="60" />
  </TripsMarker>
</template>

<script>
import TripsMarker from '@/components/trip-detail/maplib/TripsMarker'
import IconTripsStartMarker from '@/components/icons/icon-trips-start-marker.svg'

export default {
  components: {
    TripsMarker,
    IconTripsStartMarker,
  },
  props: {
    coordinates: {
      type: Object,
      required: true,
    }
  },
}
</script>
